export type Bonus = {
  id: string
  title: string
  value: string
  tagline: string
  paragraphs: string[]
  listTitle: string
  list: string[]
  benefit: string
}

export const bonuses: Bonus[] = [
  {
    id: '01',
    title: '150 Hybrid Racing Drills Library',
    value: '15',
    tagline:
      'A complete drill bank for running, sleds, carries, lunges, SkiErg, rowing, wall balls, burpees and transitions',
    paragraphs: [
      'A complete library with 150 drills organized by station and training objective. Includes running under fatigue, pacing, breathing, transitions, sled push and pull, carries, lunges, grip, SkiErg, rowing, wall balls, burpees and conditioning.',
      'Quick-reference organization lets you search by skill, equipment or training goal in seconds.',
    ],
    listTitle: 'Every drill includes',
    list: [
      'Objective',
      'Athlete level',
      'Equipment',
      'Setup',
      'Execution',
      'Duration or reps',
      'Coaching cues',
      'Common mistakes',
      'Scaling options',
      'Progression ideas',
    ],
    benefit:
      'Instead of reusing the same drills, you have a large bank of practical training options.',
  },
  {
    id: '02',
    title: '100 Mistakes, Coaching Cues & Corrections',
    value: '12',
    tagline:
      "The coach's practical guide to identifying, correcting and preventing the most common performance breakdowns",
    paragraphs: [
      'A guide with 100 common hybrid racing mistakes and exactly how to correct them, covering running, sled work, carries, lunges, SkiErg, rowing, wall balls, burpees, pacing, transitions and race execution.',
      'Also includes quick correction tables, technique checkpoints and clear "what to cue first" guidance.',
    ],
    listTitle: 'Every mistake explains',
    list: [
      'What the coach sees',
      'Why it happens',
      'How it affects performance',
      'Best correction',
      'Short coaching cues',
      'Regressions',
      'Progressions',
      'When fatigue is really the cause',
    ],
    benefit:
      'You move from simply observing mistakes to knowing how to correct them fastest.',
  },
  {
    id: '03',
    title: '50 Ready-to-Run Race Simulation Workouts',
    value: '15',
    tagline:
      'Short, half-race and full hybrid fitness racing simulations for every training phase',
    paragraphs: [
      'A complete collection of 50 ready-to-coach race simulation workouts, so you can raise race specificity progressively instead of repeating full simulations.',
      'Every session includes objective, level, duration, equipment, warm-up, exact structure, pacing target, transition focus, coaching cues, scaling, progression and recovery.',
    ],
    listTitle: 'Formats included',
    list: [
      'Short simulations',
      'Run-to-station formats',
      'Station-focused simulations',
      'Half-race sessions',
      'Full rehearsals',
      'Pacing simulations',
      'High-fatigue workouts',
      'Base phase',
      'Build phase',
      'Race-specific phase',
      'Pre-competition phase',
    ],
    benefit:
      'You select the right simulation for exactly where the athlete is in the training cycle.',
  },
  {
    id: '04',
    title: 'Athlete Assessment, Benchmark & Progress Tracking System',
    value: '12',
    tagline:
      'The complete system for measuring running, strength, engine, stations, transitions and race readiness',
    paragraphs: [
      'A structured system for evaluating athletes and monitoring progress instead of relying on subjective impressions alone.',
      'Also includes scoring systems, retesting schedules, progress dashboards, athlete profile sheets and interpretation guides.',
    ],
    listTitle: 'What you can measure',
    list: [
      'Athlete profiling',
      'Running benchmarks',
      'SkiErg tests',
      'Rowing tests',
      'Sled assessments',
      'Carry assessments',
      'Wall ball benchmarks',
      'Burpee benchmarks',
      'Grip endurance',
      'Transition testing',
      'Pacing consistency',
      'Fatigue tolerance',
      'Race-readiness checks',
    ],
    benefit:
      'You get a clear picture of athlete development and use it to guide future training.',
  },
  {
    id: '05',
    title: '40 Emergency Sessions, Small-Group & Limited-Equipment Plans',
    value: '10',
    tagline:
      'Ready-to-coach solutions for last-minute changes, small groups and limited equipment',
    paragraphs: [
      'Training plans do not always go as expected. Equipment may be unavailable, space may be limited, a session may need shortening. This bonus gives you 40 ready-to-coach solutions for those days.',
      'Durations of 20, 30, 45 and 60 minutes. Every session has objective, duration, level, equipment, substitutions, warm-up, main workout, coaching cues, scaling and cooldown.',
    ],
    listTitle: 'Situations covered',
    list: [
      'Limited time',
      'Small groups',
      'Crowded gyms',
      'Reduced space',
      'Missing sleds',
      'No SkiErg',
      'No rower',
      'Minimal equipment',
      'Mixed-level athletes',
    ],
    benefit:
      'You always have a practical backup ready when the original session cannot happen.',
  },
]

export const bonusValueRows: { label: string; value: string }[] = [
  { label: 'Bonus 1 — 150 Hybrid Racing Drills Library', value: '$15' },
  { label: 'Bonus 2 — 100 Mistakes, Coaching Cues & Corrections', value: '$12' },
  { label: 'Bonus 3 — 50 Ready-to-Run Race Simulation Workouts', value: '$15' },
  {
    label: 'Bonus 4 — Athlete Assessment, Benchmark & Progress Tracking System',
    value: '$12',
  },
  {
    label: 'Bonus 5 — 40 Emergency Sessions & Limited-Equipment Plans',
    value: '$10',
  },
]
